export const staticLabelsCompare = {
  en: {
    compareProducts: "Compare Products",
    back: "Back",
    clearResults: "Clear Results",
    compare: "Compare",
  },
  vn: {
    compareProducts: "So sánh sản phẩm",
    back: "Trở lại",
    clearResults: "Xóa kết quả",
    compare: "SO SÁNH SẢN PHẨM",
  },
};
